/* eslint-disable react/jsx-pascal-case */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

import EventCommentNew from './EventCommentNew';
import $ from 'jquery';
import moment from 'moment';

// import Event20201221_newContent from "./Event20201221_newContent";
// import Event202104_newContent from "./Event202104_newContent";
import Event202105_open from './Event202105_open';
import Event202106_shop from './Event202106_shop';
import Event202107_newContent from './Event202107_newContent';

import Event202108_shop_kwangju from './Event202108_shop_kwangju';

import Event202110_newContent from './Event202110_newContent';

import Event202110_shop_busan from './Event202110_shop_busan';
import Event20211116_otaco from './Event20211116_otaco';
import Event20211207_attac from './Event20211207_attac';
import Event202201_newContent from './Event202201_newContent';
import Event20211220_wheel from './Event20211220_wheel';

import Event202204_newContent from './Event202204_newContent';

import Event20220328_spy from './Event20220328_spy';
import Event20220425_costory from './Event20220425_costory';
import Event20220512_impact from './Event20220512_impact';

import Event202207_newContent from './Event202207_newContent';

import Event202207_ouma from './Event202207_ouma';

import Event202209_liveShopping from './Event202209_liveShopping';

import Event202210_newContent from './Event202210_newContent';
import Event202210_iba from './Event202210_iba';
import Event2022_aketo from './Event2022_aketo';
import Event2023_aketo from './Event2023_aketo';
import Event2024_aketo from './Event2024_aketo';

import Event2022_agf from './Event2022_agf';
import Event2023_agf from './Event2023_agf';
import Event2024_agf from './Event2024_agf';
import Event2025_agf from './Event2025_agf';

import Event202302_springSale from './Event202302_springSale';

import Footer from '../../components/Footer';
import { isMobile } from 'react-device-detect';
import Event202301_newContent from './Event202301_newContent';
import Event202304_newContent from './Event202304_newContent';
import Event202303_uma from './Event202303_uma';
import Event202303_ichbangi from './Event202303_ichbangi';
import Event202304_uma_gamecode from './Event202304_uma_gamecode';

import Event202305_uma_recall from './Event202305_uma_recall';
import Event202305_offical_char from './Event202305_offical_char';
import Event202307_windsword from './Event202307_windsword';
import Event202308_love from './Event202308_love';
import Event202502_love from './Event202502_love';

import Event202309_hanguywe from './Event202309_hanguywe';

import EventUMA_test from './EventUMA_test';

import Event202307_newContent from './Event202307_newContent';
import Event202310_newContent from './Event202310_newContent';

import Event202401_newContent from './Event202401_newContent';
import Event202404_newContent from './Event202404_newContent';
import Event202407_newContent from './Event202407_newContent';
import Event202410_newContent from './Event202410_newContent';
import Event202501_newContent from './Event202501_newContent';
import Event202504_newContent from './Event202504_newContent';
import Event202507_newContent from './Event202507_newContent';
import Event202510_newContent from './Event202510_newContent';
import Event202601_newContent from './Event202601_newContent';
import Event202604_newContent from './Event202604_newContent';

import Event202412_ak from './Event202412_ak';
import Event202601_ak from './Event202601_ak';

import Event20240910_popup_01 from './Event20240910_popup_01';
import Event20240910_popup_02 from './Event20240910_popup_02';

import Ticket from './Ticket';

import Event202402_sul from './Event202402_sul';
import Event202503_springSale from './Event202503_springSale';

import Event2025_kaiju from './Event2025_kaiju';
import Event202505_kaiju from './Event202505_kaiju';
import Event202507_kobayasi from './Event202507_kobayasi';
import Event202509_kaiju_popup from './Event202509_kaiju_popup';

import Event2025_aketo from './Event2025_aketo';
import Event20260209_hunter from './Event20260209_hunter';
import Event202603_love from './Event202603_love';

class EventContentNew extends Component {
  state = {
    eventIdx: this.props.childProps.eventIdx,
  };
  componentDidMount = () => {
    window.addEventListener('resize', this._getWindowSize);
    //this._getWindowSize()
    this._getWindowSize();
  };
  _getWindowSize = () => {
    $('img[usemap]').rwdImageMaps();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
    window.removeEventListener('resize', this._getWindowSize);
  };

  _onClose = () => {
    const { setEventIdx } = this.props;
    setEventIdx(0);
  };
  _goView = () => {
    const { history, setEventIdx } = this.props;
    setEventIdx(0);
    history.push('/titan');
  };
  _goSns = (gubun) => {
    let url;
    if (gubun === 'T') {
      url = 'https://twitter.com/ANIPLUSTV/status/1343479280525737987';
    } else if (gubun === 'F') {
      url = 'https://www.facebook.com/aniplushd/posts/3553215288129136';
    } else {
      url = 'https://www.youtube.com/post/Ugz41xKSabk9E_gY1NV4AaABCQ';
    }

    window.open(url, '', '');
  };
  render() {
    const { eventIdx } = this.props.childProps;
    //API로 수정 할것.
    // let bgImg, eventImg;

    // //console.log(eventIdx, pos)

    // if (parseInt(eventIdx) === 284) {
    //   bgImg = "/img/event/20201201/bg_1201.png";
    //   eventImg = "/img/event/20201201/img_1201.png";
    // } else if (parseInt(eventIdx) === 285) {
    //   bgImg = "/img/event/20201218/bg.jpg";
    //   eventImg = "";
    // } else if (parseInt(eventIdx) === 287) {
    //   bgImg = "/img/event/20210317/bg.png";
    //   eventImg = "";
    // }
    return (
      <Fragment>
        <div className="content">
          <div className="event_wrap">
            {
              parseInt(eventIdx) === 288 ? (
                <Event202105_open />
              ) : parseInt(eventIdx) === 289 ? (
                <Event202106_shop />
              ) : parseInt(eventIdx) === 290 ? (
                <Event202107_newContent />
              ) : parseInt(eventIdx) === 291 ? (
                <Event202108_shop_kwangju />
              ) : parseInt(eventIdx) === 292 ? (
                <Event202110_newContent />
              ) : parseInt(eventIdx) === 293 ? (
                <Event202110_shop_busan />
              ) : parseInt(eventIdx) === 294 ? (
                <Event20211116_otaco />
              ) : parseInt(eventIdx) === 296 ? (
                <Event20211207_attac />
              ) : parseInt(eventIdx) === 297 ? (
                <Event202201_newContent />
              ) : parseInt(eventIdx) === 298 ? (
                <Event20211220_wheel />
              ) : parseInt(eventIdx) === 299 ? (
                /*null*/
                <Event202204_newContent />
              ) : parseInt(eventIdx) === 300 ? (
                <Event20220328_spy />
              ) : parseInt(eventIdx) === 301 ? (
                <Event20220425_costory />
              ) : parseInt(eventIdx) === 302 ? (
                <Event20220512_impact />
              ) : parseInt(eventIdx) === 303 ? (
                <Event202207_newContent />
              ) : parseInt(eventIdx) === 304 ? (
                <Event202207_ouma />
              ) : parseInt(eventIdx) === 305 ? (
                <Event202209_liveShopping />
              ) : parseInt(eventIdx) === 306 ? (
                <Event202210_newContent />
              ) : parseInt(eventIdx) === 307 ? (
                <Event202210_iba />
              ) : parseInt(eventIdx) === 308 ? (
                <Event2022_agf />
              ) : parseInt(eventIdx) === 309 ? (
                <Event2022_aketo />
              ) : parseInt(eventIdx) === 310 ? (
                <Event202301_newContent />
              ) : parseInt(eventIdx) === 311 ? (
                <Event202302_springSale />
              ) : parseInt(eventIdx) === 312 ? (
                <Event202304_newContent />
              ) : parseInt(eventIdx) === 313 ? (
                <Event202303_uma />
              ) : parseInt(eventIdx) === 314 ? (
                <Event202303_ichbangi />
              ) : parseInt(eventIdx) === 315 ? (
                <Event202304_uma_gamecode />
              ) : parseInt(eventIdx) === 316 ? (
                <Event202305_uma_recall />
              ) : parseInt(eventIdx) === 317 ? (
                <Event202305_offical_char />
              ) : parseInt(eventIdx) === 318 ? (
                <Event202307_windsword />
              ) : parseInt(eventIdx) === 319 ? (
                <Event202307_newContent />
              ) : parseInt(eventIdx) === 320 ? (
                <Event202308_love />
              ) : parseInt(eventIdx) === 321 ? (
                <Event202309_hanguywe />
              ) : parseInt(eventIdx) === 322 ? (
                <Event202310_newContent />
              ) : parseInt(eventIdx) === 323 ? (
                <Ticket />
              ) : parseInt(eventIdx) === 324 ? (
                <Event2023_aketo />
              ) : parseInt(eventIdx) === 325 ? (
                <Event2023_agf />
              ) : parseInt(eventIdx) === 326 ? (
                <Event202401_newContent />
              ) : parseInt(eventIdx) === 327 ? (
                <Event202402_sul />
              ) : parseInt(eventIdx) === 328 ? (
                <Event202404_newContent />
              ) : parseInt(eventIdx) === 329 ? (
                <Event202407_newContent />
              ) : parseInt(eventIdx) === 330 ? (
                <Event20240910_popup_01 />
              ) : parseInt(eventIdx) === 331 ? (
                <Event20240910_popup_02 />
              ) : parseInt(eventIdx) === 332 ? (
                <Event202410_newContent />
              ) : parseInt(eventIdx) === 333 ? (
                <Event2024_aketo />
              ) : parseInt(eventIdx) === 334 ? (
                <Event2024_agf />
              ) : parseInt(eventIdx) === 335 ? (
                <Event202501_newContent />
              ) : parseInt(eventIdx) === 336 ? (
                <Event202412_ak />
              ) : parseInt(eventIdx) === 337 ? (
                <Event202502_love />
              ) : parseInt(eventIdx) === 338 ? (
                <Event202503_springSale />
              ) : parseInt(eventIdx) === 339 ? (
                <Event202504_newContent />
              ) : parseInt(eventIdx) === 340 ? (
                <Event2025_kaiju />
              ) : parseInt(eventIdx) === 341 ? (
                <Event202505_kaiju />
              ) : parseInt(eventIdx) === 342 ? (
                <Event202507_newContent />
              ) : parseInt(eventIdx) === 343 ? (
                <Event202507_kobayasi />
              ) : parseInt(eventIdx) === 344 ? (
                <Event202509_kaiju_popup />
              ) : parseInt(eventIdx) === 345 ? (
                <Event202510_newContent />
              ) : parseInt(eventIdx) === 346 ? (
                <Event2025_aketo />
              ) : parseInt(eventIdx) === 347 ? (
                <Event2025_agf />
              ) : parseInt(eventIdx) === 348 ? (
                <Event202601_newContent />
              ) : parseInt(eventIdx) === 349 ? (
                <Event202601_ak />
              ) : parseInt(eventIdx) === 350 ? (
                <Event20260209_hunter />
              ) : parseInt(eventIdx) === 351 ? (
                <Event202604_newContent />
              ) : parseInt(eventIdx) === 352 ? (
                <Event202603_love />
              ) : null //  //
            }

            {/*덧글*/}
            {parseInt(eventIdx) === 315 ||
            parseInt(eventIdx) === 323 ||
            parseInt(eventIdx) === 316 ? null : (
              <EventCommentNew eventIdx={eventIdx} />
            )}
          </div>
        </div>
        {isMobile ? null : parseInt(eventIdx) === 323 ? null : <Footer />}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(EventContentNew));
